// extracted by mini-css-extract-plugin
module.exports = {"root":"root___qB8UJ","inner":"inner___3sCAc"};